import { firebaseMedia } from 'content/media/firebaseMedia';

const moreDemoAccounts = [
      {
      name: "Hustler Harper",
      description: "Focused on saving and investing smartly to achieve major life goals like purchasing a home.",
      avatar: "H",
      ageProfile: "30-40 years",
      img:firebaseMedia?.demoprofile_harper,
      familySituation: "Single",
      assets: "Savings: $25K, Stock Portfolio: $40K, Home Fund: $60K",
      liabilities: "Student Loan: $30K",
      income: "$150K - $200K Annually",
      expenses: "Rent: $1,800, Living: $2,200, Savings: $1,200",
      portfolioDetails: "Stocks: 40%, ETF: 30%, Crypto:10%, Cash: 20%",
      networth: "$100K - $200k",
      networthNumber:"150000",
      incomeNumber:"200000"
    },
     // {
    //   name: "Go-Getter Grace",
    //   description: "Balancing career growth and thoughtful financial planning for future stability.",
    //   avatar: "G",
    //   ageProfile: "30-40 years",
    //   familySituation: "Single",
    //   assets: "Savings: $18K, 401K: $35K, Investment Account: $25K",
    //   liabilities: "Student Loan: $20K, Personal Loan: $10K",
    //   income: "$95K Annually",
    //   expenses: "Rent: $1,600, Living: $1,900, Savings: $1,300",
    //   portfolioDetails: "Stocks: 40%, Bonds: 30%, Cash: 30%",
    //   networth: "$48K"
    // },
    // {
    //   name: "Prosperous Priya",
    //   description: "A well-rounded professional juggling career, family, and future financial aspirations.",
    //   avatar: "P",
    //   ageProfile: "35-40 years",
    //   familySituation: "Married with kids",
    //   assets: "Home: $500K, Savings: $80K, 401K: $150K",
    //   liabilities: "Mortgage: $300K, Car Loan: $15K",
    //   income: "$250K Annually (Joint)",
    //   expenses: "Mortgage: $2,500, Living: $3,000, Kids' Education: $1,500",
    //   portfolioDetails: "Stocks: 70%, Bonds: 20%, Cash: 10%",
    //   networth: "$415K"
    // },
    {
      name: "Grounded Gabriel",
      description: "Thoughtful and steady, committed to providing for family needs while preparing for the future.",
      avatar: "G",
      ageProfile: "40-50 years",
      img:firebaseMedia?.demoprofile_gabriel,
      familySituation: "Married with kids",
      assets: "Home: $550K, Savings: $100K, 401K: $180K",
      liabilities: "Mortgage: $320K, Car Loan: $18K",
      income: "$200-$300K Annually",
      expenses: "Mortgage: $2,700, Living: $3,100, Kids' Education: $1,600",
      portfolioDetails: "Stocks: 10%, ETF: 80%, Cash: 10%",
      networth: "$400K - $700K",
      networthNumber:"500000",
      incomeNumber:"260000"

    },
    // {
    //   name: "Legacy Linda",
    //   description: "Focused on creating a secure future for her family while planning generational wealth.",
    //   avatar: "L",
    //   ageProfile: "50-55 years",
    //   familySituation: "Married with kids",
    //   assets: "Savings: $200K, Home: $750K, 401K: $500K, Other Investments: $200K",
    //   liabilities: "Mortgage: $200K, No Other Debt",
    //   income: "$300K Annually",
    //   expenses: "Mortgage: $2,500, Living: $3,500, Retirement Planning: $1,500",
    //   portfolioDetails: "Stocks: 50%, Bonds: 40%, Real Estate: 10%",
    //   networth: "$1.45M" 
    // },

    {
      name: "Steady Stephen",
      description: "Confident and strategic in managing financial assets to meet lifelong goals.",
      avatar: "S",
      ageProfile: "50-60 years",
      img:firebaseMedia?.demoprofile_stephan,
      familySituation: "Married",
      assets: "Savings: $300K, Home: $800K, 401K: $700K, Real Estate: $500K",
      liabilities: "Mortgage: $250K, No Other Debt",
      income: "$350K - $600K Annually",
      expenses: "Mortgage: $2,800, Living: $3,700, Retirement Planning: $2,000",
      portfolioDetails: "Stocks: 35%,ETF:30%, Bonds: 20%, Real Estate: 10%, Cash: 5%",
      networth: "$2.5M - $5M",
      networthNumber:"3500000",
      incomeNumber:"450000"
    },
  ]


const clientDemoAccounts = [
        {
          name: "Emma Thompson",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          avatar: "E",
          img: firebaseMedia?.demoprofile_vera,
          ageProfile: "25-30 years",
          familySituation: "Single",
          assets: "Savings: $10K, IRA: $20K",
          liabilities: "Student Loan: $25K, Credit Card: $5K",
          income: "$200K+ Annually",
          expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
          portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
          networth: "$100K - $500K",
          networthNumber: "120000",
          incomeNumber: "75000"
        },
        {
          name: "James Wilson",
          avatar: "J",
          img: firebaseMedia?.demoprofile_alex,
          ageProfile: "25-30 years",
          familySituation: "Single",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $10K, IRA: $20K",
          liabilities: "None",
          income: "$100K - $200K Annually",
          expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
          portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
          networth: "$10K - $50K",
          networthNumber: "75000",
          incomeNumber: "100000"
        },
        {
          name: "Sarah Chen",
          avatar: "S",
          img: firebaseMedia?.demoprofile_vera,
          ageProfile: "20-25 years",
          familySituation: "Domestic Partnership",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $15K, 401K: $30K",
          liabilities: "Mortgage: $200K, Auto Loan: $15K",
          income: "$100K - $200K Annually",
          expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
          portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
          networth: "$50K - $100K",
          networthNumber: "250000",
          incomeNumber: "75000"
        },
        {
          name: "Michael Anderson",
          avatar: "M",
          img: firebaseMedia?.demoprofile_alex,
          ageProfile: "25-30 years",
          familySituation: "Married",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $5K, 401K: $10K",
          liabilities: "None",
          income: "$100K - $200K Annually",
          expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
          portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
          networth: "$50K - $100K",
          networthNumber: "75000",
          incomeNumber: "100000"
        },
        {
          name: "Lisa Rodriguez",
          avatar: "L",
          img: firebaseMedia?.demoprofile_vera,
          ageProfile: "25-30 years",
          familySituation: "Single",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $10K, IRA: $20K",
          liabilities: "None",
          income: "$100K - $200K Annually",
          expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
          portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
          networth: "$100K - $500K",
          networthNumber: "250000",
          incomeNumber: "100000"
        },
        {
          name: "David Kim",
          avatar: "D",
          img: firebaseMedia?.demoprofile_alex,
          ageProfile: "25-30 years",
          familySituation: "Married",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $10K, IRA: $20K",
          liabilities: "Student Loan: $25K, Credit Card: $5K",
          income: "$200K+ Annually",
          expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
          portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
          networth: "$100K - $500K",
          networthNumber: "450000",
          incomeNumber: "150000"
        },
        {
          name: "Rachel Greene",
          avatar: "R",
          img: firebaseMedia?.demoprofile_vera,
          ageProfile: "30-35 years",
          familySituation: "Married",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $15K, 401K: $30K",
          liabilities: "Mortgage: $200K, Auto Loan: $15K",
          income: "$100K - $200K Annually",
          expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
          portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
          networth: "$50K - $100K",
          networthNumber: "75000",
          incomeNumber: "100000"
        },
        {
          name: "Thomas Martinez",
          avatar: "T",
          img: firebaseMedia?.demoprofile_alex,
          ageProfile: "30-35 years",
          familySituation: "Married",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $10K, IRA: $20K",
          liabilities: "None",
          income: "$200K+ Annually",
          expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
          portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
          networth: "$100K - $500K",
          networthNumber: "250000",
          incomeNumber: "200000"
        },
        {
          name: "Jennifer Wu",
          avatar: "J",
          img: firebaseMedia?.demoprofile_vera,
          ageProfile: "25-30 years",
          familySituation: "Married",
          description: "A driven young professional keen on turning high earnings into lasting financial success.",
          assets: "Savings: $15K, 401K: $30K",
          liabilities: "Student Loan: $25K, Credit Card: $5K",
          income: "$100K - $200K Annually",
          expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
          portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
          networth: "$100K - $500K",
          networthNumber: "120000",
          incomeNumber: "100000"
        },
        {
            name: "Robert Taylor",
            avatar: "R",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "30-35 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $10K, IRA: $20K",
            liabilities: "None",
            income: "$200K+ Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
            networth: "$100K - $500K",
            networthNumber: "250000",
            incomeNumber: "150000"
          },
          {
            name: "Alexandra Foster",
            avatar: "A",
            img: firebaseMedia?.demoprofile_vera,
            ageProfile: "25-30 years",
            familySituation: "Single",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $15K, 401K: $30K",
            liabilities: "Student Loan: $25K, Credit Card: $5K",
            income: "$100K - $200K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
            networth: "$50K - $100K",
            networthNumber: "75000",
            incomeNumber: "100000"
          },
          {
            name: "Marcus Johnson",
            avatar: "M",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "30-35 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $10K, IRA: $20K",
            liabilities: "Mortgage: $200K, Auto Loan: $15K",
            income: "$200K+ Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
            networth: "$100K - $500K",
            networthNumber: "250000",
            incomeNumber: "200000"
          },
          {
            name: "Sophie Chen",
            avatar: "S",
            img: firebaseMedia?.demoprofile_vera,
            ageProfile: "25-30 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $15K, 401K: $30K",
            liabilities: "None",
            income: "$100K - $200K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
            networth: "$50K - $100K",
            networthNumber: "120000",
            incomeNumber: "100000"
          },
          {
            name: "Daniel Rodriguez",
            avatar: "D",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "30-35 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $10K, IRA: $20K",
            liabilities: "None",
            income: "$200K+ Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
            networth: "$100K - $500K",
            networthNumber: "450000",
            incomeNumber: "150000"
          },
          {
            name: "Jason Schmidt",
            avatar: "E",
            img: firebaseMedia?.demoprofile_vera,
            ageProfile: "25-30 years",
            familySituation: "Single",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $5K, 401K: $10K",
            liabilities: "Student Loan: $25K, Credit Card: $5K",
            income: "$100K - $200K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
            networth: "$10K - $50K",
            networthNumber: "30000",
            incomeNumber: "100000"
          },
          {
            name: "William Chang",
            avatar: "W",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "30-35 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $15K, 401K: $30K",
            liabilities: "Mortgage: $200K, Auto Loan: $15K",
            income: "$200K+ Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
            networth: "$100K - $500K",
            networthNumber: "250000",
            incomeNumber: "200000"
          },
          {
            name: "Olivia Martinez",
            avatar: "O",
            img: firebaseMedia?.demoprofile_vera,
            ageProfile: "25-30 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $10K, IRA: $20K",
            liabilities: "None",
            income: "$100K - $200K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
            networth: "$50K - $100K",
            networthNumber: "120000",
            incomeNumber: "100000"
          },
          {
            name: "Benjamin Kim",
            avatar: "B",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "30-35 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $15K, 401K: $30K",
            liabilities: "None",
            income: "$200K+ Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
            networth: "$100K - $500K",
            networthNumber: "450000",
            incomeNumber: "200000"
          },
          {
            name: "Victoria Patel",
            avatar: "V",
            img: firebaseMedia?.demoprofile_vera,
            ageProfile: "25-30 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $10K, IRA: $20K",
            liabilities: "Student Loan: $25K, Credit Card: $5K",
            income: "$100K - $200K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
            networth: "$50K - $100K",
            networthNumber: "75000",
            incomeNumber: "100000"
          },
          {
            name: "Nathan Wright",
            avatar: "N",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "25-30 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $15K, 401K: $30K",
            liabilities: "Mortgage: $200K, Auto Loan: $15K",
            income: "$100K - $200K Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
            networth: "$100K - $500K",
            networthNumber: "120000",
            incomeNumber: "100000"
          },
          {
            name: "Robert Chen",
            avatar: "R",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "30-35 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $10K, IRA: $20K",
            liabilities: "None",
            income: "$200K+ Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Real Estate: 50%, Stocks: 30%, Cash: 20%",
            networth: "$100K - $500K",
            networthNumber: "250000",
            incomeNumber: "150000"
          },
          {
            name: "Lisa Park",
            avatar: "L",
            img: firebaseMedia?.demoprofile_vera,
            ageProfile: "25-30 years",
            familySituation: "Single",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $15K, 401K: $30K",
            liabilities: "Student Loan: $25K, Credit Card: $5K",
            income: "$100K - $200K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
            networth: "$50K - $100K",
            networthNumber: "75000",
            incomeNumber: "100000"
          },
          {
            name: "Michael Wilson",
            avatar: "M",
            img: firebaseMedia?.demoprofile_alex,
            ageProfile: "30-35 years",
            familySituation: "Married",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $15K, 401K: $30K",
            liabilities: "None",
            income: "$200K+ Annually",
            expenses: "Mortgage: $2,500, Living: $3,000, Savings: $2,000",
            portfolioDetails: "Stocks: 80%, Bonds: 10%, Cash: 10%",
            networth: "$100K - $500K",
            networthNumber: "250000",
            incomeNumber: "150000"
          },
          {
            name: "Sarah Thompson",
            avatar: "S",
            img: firebaseMedia?.demoprofile_vera,
            ageProfile: "25-30 years",
            familySituation: "Single",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            assets: "Savings: $10K, IRA: $20K",
            liabilities: "Student Loan: $25K, Credit Card: $5K",
            income: "$100K - $200K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
            networth: "$50K - $100K",
            networthNumber: "75000",
            incomeNumber: "100000"
          }

      ];
      

      export const demoAccounts = [
          ...clientDemoAccounts,
          {
            name: "Ambitious Alex",
            description: "A driven young professional keen on turning high earnings into lasting financial success.",
            avatar: "A",
            img:firebaseMedia?.demoprofile_alex,
            ageProfile: "25-30 years",
            familySituation: "Single",
            assets: "Savings: $5K, 401K: $10K",
            liabilities: "Student Loan: $25K, Credit Card: $5K",
            income: "$50K - $100K Annually",
            expenses: "Rent: $1,500, Living: $2,000, Savings: $1,000",
            portfolioDetails: "Stocks: 60%,Crypto:10%, Cash: 30%",
            networth: "$10K - $50k",
            networthNumber:"30000",
            incomeNumber:"100000"
          },
          {
            name: "Thrive Together Tim & Tara",
            description: "A power couple prioritizing family stability while growing their wealth.",
            avatar: "T",
            img:firebaseMedia?.demoprofile_timtara,
            ageProfile: "40-50 years",
            familySituation: "Married with kids",
            assets: "Home: $600K, Savings: $90K, Joint Investments: $200K",
            liabilities: "Mortgage: $350K, Car Loan: $20K",
            income: "$200K - $400K Annually (Joint)",
            expenses: "Mortgage: $2,800, Living: $3,200, Kids' Education: $1,700",
            portfolioDetails: "Stocks: 20%, ETF:50%, Bonds: 20%, Cash: 10%",
            networth: "$500K - $800K",
            networthNumber:"600000",
            incomeNumber:"300000",
          },
          
         {
              name: "Visionary Vera",
              description: "A forward-thinker navigating family priorities while building wealth for the next generation.",
              avatar: "V",
              img:firebaseMedia?.demoprofile_vera,
              ageProfile: "50+ years",
              familySituation: "Married with kids",
              assets: "Savings: $400K, Home: $900K, 401K: $800K, Trust Fund: $600K",
              liabilities: "Mortgage: $300K, No Other Debt",
              income: "$500K - $1M Annually",
              expenses: "Mortgage: $3,000, Living: $4,000, Retirement Planning: $2,500",
              portfolioDetails: "Stocks: 30%,ETF:40%, Bonds: 10%, Real Estate: 10%, Crypto: 5%, Cash: 5%",
              networth: "$7M - $10M",
              networthNumber:"7000000",
              incomeNumber:"600000"
            },
        ]  
    